import { connect } from 'react-redux';

import DashboardPage from './dashboard-page.component';
import { DEFAULT_STAT_VALUE } from './dashboard-page.constants';
import { IDashboardPageStoreProps } from './dashboard-page.types';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State): IDashboardPageStoreProps => {
    return {
        softCloseMode: state.friendsReferral.campaignInfo.softCloseMode,
        referrerId: state.friendsReferral.playerInfo?.referrerId ?? DEFAULT_STAT_VALUE,
        isConverted: state.friendsReferral.playerInfo?.isConverted ?? false,
        shouldInheritStyles: state.config.shouldInheritStyles
    };
};

export default connect(mapStateToProps)(DashboardPage);
